import YUSPUtil from '../../core/util/yusp_util';
import { Variation } from '../models/variation';
import { isSoloare, JsEnv, SiteType } from '../../core/models/js_env';
import { TypedEvent } from '../../core/typed_event';
import { RrRepository } from '../../core/repositories/rr_repository';
import { getRrAreaData } from '../../core/models/rr/rr_util';
import { createRrItemModalRequestParam, createRrRequestParam } from '../models/rr/set_rr_request';
import { RrContainer } from '../views/pc/rr_container';
import { AddCartModalAction } from '../../core/actions/add_cart/modal_action';
import {
  CatalogItemCodesWithElementId,
  doShowRtoaster,
  RtoasterParameter
} from '../../core/models/rtoaster/rtoaster_utils';
import { setParametersCallBack } from '../models/rtoaster/set_rtoaster_parameter';
import { SubstituteItemAreaAction } from '../../core/actions/substitute_item/substitute_item_area_action';
import { ReviewButtonAnalyticsData } from '../../core/models/analytics/review_button_analytics_data';
import { AdobeAnalyticsData } from '../../core/models/analytics/adobe_analytics_data';
import { Env } from '../../core/env'
import TableTooltipAction from './table_tooltip_action';
import LazyUtil from '../../core/util/lazy_util';
import { VariationJsEnv } from '../models/variation_js_env';
import { RrItemModalContainer } from '../views/pc/rr_item_modal_container';
import { AnalyticsItems } from '../../core/models/analytics/analytics_items';

const SUPPLIER_ID = 'P00001';

export class VariationAction {
  static REFRESH_TABLE = new TypedEvent<Document>();
  static readonly REVIEW_CARD_EVENT = new TypedEvent<AdobeAnalyticsData>();
  static readonly REVIEW_USER_NAME_EVENT = new TypedEvent<AdobeAnalyticsData>();
  static readonly VIEW_ALL_REVIEWS_EVENT = new TypedEvent<AdobeAnalyticsData>();
  static WRITE_REVIEW_EVENT = new TypedEvent<ReviewButtonAnalyticsData>();
  static readonly RR_ITEM_Modal_EVENT = new TypedEvent<VariationJsEnv>();
  static readonly CART_ADD_TOGETHER_EVENT = new TypedEvent<AnalyticsItems>();

  private static state: Variation;
  private static rrRepository: RrRepository;

  static init(env: JsEnv, containerClass: any) {
    this.state = new Variation(env.PAGE);

    this.rrRepository = new RrRepository();
    const model = this.state.getModel();

    // カゴモーダルの初期化
    AddCartModalAction.init();

    // カゴモーダルのRRレコメンド設定
    const addCartButtons = document.getElementsByClassName("cartAreaAddCart");
    const addCartButtonArr = Array.from(addCartButtons);
    addCartButtonArr.forEach((addCartButton) => {
      /// カゴに入れるボタン押下
      addCartButton.addEventListener('click', (e) => {
        /// カゴ投入ボタンが押下されていることを確認する
        const target = e.target as HTMLElement;
        if (target.tagName === 'BUTTON') {
          const catalogItemCode = target.dataset.catalogItemCode as string;
          VariationAction.addCartButtonRrRecommend(catalogItemCode);
        }
      });
    });

    if (!isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend && window['RR'] !== undefined) {
      window['RR'].jsonCallback = this.renderRr.bind(this);
      new RrItemModalContainer() // NOSONAR

      this.rrRepository.sendRequestToRrServer(createRrRequestParam(model), false);
    }

    // 下のRtoasterの分岐は削除予定なので独立させておく
    if (isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend) {
      this.rrRepository.sendRequestToRrServer(createRrRequestParam(model), true);
    }

    if (isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend && typeof Rtoaster !== 'undefined') {
      const elementIds = ['tr_recom_DAD01050_001', 'tr_recom_DAD01050_002'];

      const rtoasterParameter: RtoasterParameter = {
        appKeys: { ctgry1CdView: env.PAGE.llCategoryCode, ctgry2CdView: env.PAGE.lCategoryCode },
        catalogItemCode: SUPPLIER_ID + env.PAGE.topItemCode,
        categoryCode: env.PAGE.mCategoryCode,
      }

      doShowRtoaster({
        elementIds: elementIds,
        showRtoasterAreaCallBack: this.showRtoasterArea.bind(this),
        setParametersCallBack: setParametersCallBack,
        rtoasterParameter: rtoasterParameter
      });
    }

    window.addEventListener('load', function () {
      SubstituteItemAreaAction.setAnalyticsItems(
        'variation',
        '#variations-table-body .o-table_tr',
        '[data-substitute-catalog-item-code]'
      );
    });
    // YUSP連携 ユーザーID連携、VIEWイベント
    YUSPUtil.register({
      enableUserId: true,
      enableView: true,
    });

    // IE11のトラバスバージョンで、左固定のカラムと右のスクロール可能なカラムの高さを揃えるために、
    // 同じテーブルを複製して、左固定のカラムは高さ調整済みの、複製後のものを表示する、という処理が入っている
    // https://github.com/askul/trylion-phase1-club-template/blob/develop/src/cms/assets/js/ieStickyCol.ts
    // 価格でソートする選択肢は、左固定のカラム（複製されたもの）にあるため、イベントのバインドがなくなる。
    // 複製されるものもイベントを呼び出せるように、ソート処理を外だしにする必要がある
    Env.FUNCTIONS['variationSortPriceAsc'] = TableTooltipAction.sortPriceAsc.bind(this);
    Env.FUNCTIONS['variationSortPriceDesc'] = TableTooltipAction.sortPriceDesc.bind(this);

    // 外部ファイルにjsが含まれた場合、実行されるよう
    LazyUtil.enableExternalFileScript();

    return new containerClass(this.state.getModel());
  }

  private static async showRtoasterArea(catalogItemCodesWithElementIds: CatalogItemCodesWithElementId[]) {
    const state = this.state;

    // catalogItemCodesWithElementIdsをforEachで回すとasync/awaitがうまく機能しないため、
    // リストからelmenetIdを指定して取得する
    const upperCatalogItemCodes = catalogItemCodesWithElementIds.filter(catalogItemCodesWithElementId => catalogItemCodesWithElementId.elementId === 'tr_recom_DAD01050_001')[0].catalogItemCodes
    const upperCarouselItems = await this.rrRepository.getRrItemsDetail(upperCatalogItemCodes, false, SiteType.SOLOARE);
    state.setRrAreaDataVariationUpper(upperCarouselItems, 'この商品を買っている方はこんな商品も買っています');

    const lowerCatalogItemCodes = catalogItemCodesWithElementIds.filter(catalogItemCodesWithElementId => catalogItemCodesWithElementId.elementId === 'tr_recom_DAD01050_002')[0].catalogItemCodes
    const lowerCarouselItems = await this.rrRepository.getRrItemsDetail(lowerCatalogItemCodes, false, SiteType.SOLOARE);
    state.setRrAreaDataVariationLower(lowerCarouselItems, 'この商品を見ている方はこんな商品にも興味をもっています');

    new RrContainer(state.getModel()); // NOSONAR
  }

  private static async renderRr() {
    const rrDataVariationsUpper = await getRrAreaData(this.state.getModel().rrAreaProfileVariationsUpper);
    this.state.setRrAreaDataVariationUpper(rrDataVariationsUpper.items, rrDataVariationsUpper.title);

    const rrDataVariationsLower = await getRrAreaData(this.state.getModel().rrAreaProfileVariationsLower);
    this.state.setRrAreaDataVariationLower(rrDataVariationsLower.items, rrDataVariationsLower.title);

    return new RrContainer(this.state.getModel());
  }

  /// レビューを書くボタン　計測
  static reviewButton(button, index, array) {
    let buttonSize = array.length;
    let analyticsData: ReviewButtonAnalyticsData = {
      analyticsData: {
        reviewButtonIndex: buttonSize > 1 ? index + 1 : null
      },
      target: button,
      linkName: 'ReviewWrite',
    }
    this.WRITE_REVIEW_EVENT.trigger(analyticsData);
  }

  private static addCartButtonRrRecommend(catalogItemCode: string) {
    const model = this.state.getModel();

    // おすすめ情報設定offの場合RR部分は実行しない
    if (model.shouldDisplayRecommend && window['RR'] !== undefined) {
      window['RR'].jsonCallback = this.renderRrModal.bind(this);
      this.rrRepository.sendRequestToRrServer(createRrItemModalRequestParam(model, catalogItemCode));
    }
  }

  private static async renderRrModal() {
    const model = this.state.getModel()

    const rrAreaProfileItemModal = await getRrAreaData(model.rrAreaProfileItemModal)
    this.state.setRrAreaProfileItemModal(rrAreaProfileItemModal.items, rrAreaProfileItemModal.title);

    if (rrAreaProfileItemModal.items.length > 0) {
      this.RR_ITEM_Modal_EVENT.trigger(model);
    }
  }
}
